/**
 * Small parsers of a BI dashboard's view in the URL (CU-869fmjzrh S2; first in Season's `viewState.js`).
 * Pure and alias-free.
 */

export const MAX_IDS = 200

export const positiveInt = v => {
	const n = Number(v)
	return Number.isInteger(n) && n > 0 ? n : null
}

export const flag = v => (v === '1' || v === 1 || v === true ? true : v === '0' || v === 0 || v === false ? false : null)

/** `"3,1,3"` → `[3, 1]`; `null` when any id is not a positive int or there are more than `max` */
export const idList = (v, max = MAX_IDS) => {
	const ids = String(v || '').split(',').filter(Boolean).map(positiveInt)
	return ids.length && ids.length <= max && ids.every(Boolean) ? [...new Set(ids)] : null
}
